<style scoped lang="scss" type="text/scss">
    .contestant-application-container {
        .info-panel {
            margin-bottom: 1rem;
        }
    }
</style>

<template>
    <div class="contestant-application-container">
        <info-panel class="info-panel">批准成功后，该成员会加入参赛队，之后可在成员管理中设定其身份</info-panel>
        <div class="global-relative">
            <loading-placeholder :loading="loadingRequesting"></loading-placeholder>
            <el-table :data="contestantApplications" stripe border size="small" style="width: 100%">
                <el-table-column type="index" :index="indexMethod" label="序号" align="center" width="80"></el-table-column>
                <el-table-column prop="competition_name" label="赛事名称" align="center" min-width="180"></el-table-column>
                <el-table-column prop="school_name" label="学校名称" align="center" min-width="120"></el-table-column>
                <el-table-column prop="team_name" label="队伍名称" align="center" min-width="120"></el-table-column>
                <el-table-column prop="personal_name" label="申请人姓名" align="center" min-width="100"></el-table-column>
                <el-table-column prop="create_time_text" label="申请时间" align="center" width="140"></el-table-column>
                <el-table-column prop="max_person_player_number" label="每人限报次数（包含未审批）与限制" align="center"
                                 min-width="100">
                    <template slot-scope="scope">
                        <div :style="{ color: scope.row.max_person_player_number.includes('>') ? 'red' : 'black'}">
                            {{ scope.row.max_person_player_number }}
                        </div>
                    </template>
                </el-table-column>
                <el-table-column label="操作" width="170" align="center">
                    <template slot-scope="scope">
                        <el-button size="mini" type="primary" plain @click="approve(scope.row)"
                                   :loading="scope.row.id === requestingId && approveRequesting">
                            批准
                        </el-button>
                        <el-button size="mini" type="danger" plain @click="reject(scope.row)"
                                   :loading="scope.row.id === requestingId && rejectRequesting">
                            驳回
                        </el-button>
                    </template>
                </el-table-column>
            </el-table>
        </div>

        <pagination :page-size="pageSize" :current-page.sync="currentPage" :total="total"
                    @current-change="loadPlayerUnfinishedContestantApplications">
        </pagination>
    </div>
</template>

<script>
    import InfoPanel from '../../../../../components/info-panel/index';
    import {handleContestantApplications} from '../../../../../utils/data-handler';
    import {indexMethod, updatePageOption} from '../../../../../utils/page';

    export default {
        name: '',
        components: {
            InfoPanel
        },
        data () {
            return {
                requestingId: null,
                contestantApplications: [],
                loadingRequesting: false,
                approveRequesting: false,
                rejectRequesting: false,
                pageSize: 10,
                total: 0,
                currentPage: 1
            };
        },
        computed: {
            currentManagedPlayerId () {
                return this.$store.state.player.currentManagedPlayerId;
            },
            page () {
                return {
                    page_size: this.pageSize,
                    page_num: this.currentPage
                };
            }
        },
        watch: {
            currentManagedPlayerId: {
                immediate: true,
                handler (currentManagedPlayerId) {
                    if (currentManagedPlayerId === null || currentManagedPlayerId === undefined) return;
                    this.loadPlayerUnfinishedContestantApplications();
                }
            }
        },
        methods: {
            indexMethod (index) {
                return indexMethod(index, this);
            },
            loadPlayerUnfinishedContestantApplications () {
                this.$normalRequest('player/loadPlayerUnfinishedContestantApplications', {
                    id: this.currentManagedPlayerId,
                    ...this.page
                }, false, false, this, 'loadingRequesting').then(data => {
                    updatePageOption(this, data);
                    this.contestantApplications = handleContestantApplications(data.list);
                    // console.log(this.contestantApplications)

                });
            },
            approve (data) {
                const contestantApplicationId = data.id;
                this.requestingId = contestantApplicationId;
                this.$normalConfirm('确认批准？', '批准操作无法撤回，请谨慎操作').then(_ => {
                    this.$normalRequest('player/approveContestant', {
                        id: contestantApplicationId
                    }, '已完成批准操作', true, this, 'approveRequesting').then(_ => {
                        this.loadPlayerUnfinishedContestantApplications();
                    }).catch(_ => {
                    });
                }).catch(_ => {
                });
            },
            reject (data) {
                const contestantApplicationId = data.id;
                this.requestingId = contestantApplicationId;
                this.$normalPrompt('确认驳回？', '请输入驳回理由（ 可选 ）', 120).then(data => {
                    this.$normalRequest('player/rejectContestant', {
                        id: contestantApplicationId,
                        reason: data
                    }, '已完成驳回操作', true, this, 'rejectRequesting').then(_ => {
                        this.loadPlayerUnfinishedContestantApplications();
                    }).catch(_ => {
                    });
                });
            }
        }
    };
</script>
